module.exports = __webpack_public_path__ + "img/19800.79257ef4.jpg";